import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import { useSelector } from 'react-redux';
import { CONCURSOAPI } from '../const';
import { isFulfilledAction, isPendingAction } from '../utils/redux';

type State = {
  error: string; //mensaje de error
  message: string; //mensaje correcto
  success: boolean; // termino la operacion
  loading: boolean; //procesando la operacion
  fail: boolean; //falló la operacion
};
const initialState: State = {
  error: '',
  message: '',
  loading: false,
  success: false,
  fail: false,
};

const sliceName = 'inscripciones';

type DatosPostulante = {
  observaciones: string;
  pseudonimo: string;
};
export type RequisitosPuestoDeclarados = {
  cumple: boolean;
  idRequisitoPuesto: number;
  presentoDocumentacion: boolean;
};
type DatosInscripcion = {
  datosPostulante: DatosPostulante;
  requisitosPuestoDeclarados: RequisitosPuestoDeclarados[];
};

export type PostInscribirseProps = {
  idUsuario: number;
  idPuesto: number | undefined;
  datosInscripcion: DatosInscripcion;
};

export const postInscribirse = createAsyncThunk<string, PostInscribirseProps>(
  `${sliceName}/post`,
  async ({ idPuesto, datosInscripcion, idUsuario }) => {
    try {
      const response = await axios.post(
        `${CONCURSOAPI}/puesto/inscripcion/${idUsuario}/${idPuesto}`,
        datosInscripcion,
      );
      if (response.status >= 200 && response.status < 300) {
        return response.data;
      } else {
        throw new Error('Error inesperado');
      }
    } catch (error) {
      throw error;
    }
  },
);

const inscripcionesSlice = createSlice({
  name: sliceName,
  initialState,
  reducers: {
    cleanMsg: (state) => ({ ...state, message: '', error: '' }),
    cleanState: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(postInscribirse.fulfilled, (state, action) => {
      state.message = action.payload;
      state.success = true;
      state.loading = false;
    });

    builder.addCase(postInscribirse.rejected, (state, action) => {
      state.loading = false;

      if (action.error.message?.endsWith('406')) {
        state.error = 'Ya se encuentra inscripto';
      }
      if (action.error.message?.endsWith('500')) {
        state.error = 'Error en el servidor.';
      }

      state.fail = true;
    });

    builder.addCase(postInscribirse.pending, (state) => {
      state.loading = true;
      state.fail = false;
    });

    builder.addMatcher(isPendingAction(sliceName), (state) => {
      state.loading = true;
    });

    builder.addMatcher(isFulfilledAction(sliceName), (state) => {
      state.loading = false;
      state.success = true;
      state.message = 'Inscripcion Exitosa!';
    });
  },
});

export const useInscripciones = () => useSelector((state: any) => state.inscripciones) as State;
export const { cleanMsg, cleanState } = inscripcionesSlice.actions;
export const inscripcionesReducer = inscripcionesSlice.reducer;
export default inscripcionesReducer;
